import React, { useEffect, useState } from 'react';
import { Stack } from 'office-ui-fabric-react';

import { BCRegionsProps, BCRegionDetails } from './DetailsInfo.types';
import { Styled } from './DetailsInfo.styles';

import { typeSafeObjectKeys } from './typings';
import { bcRegions } from './consts';
import { secureRequest } from 'utils/request';

export const BCRegions: React.FC<BCRegionsProps> = ({ id }) => {
  const [details, setDetails] = useState<BCRegionDetails | null>(null);

  useEffect(() => {
    const request = async () => {
      const data = await secureRequest<BCRegionDetails>(
        '/api/v1/pass/departmentcontroll/' + id
      );
      if (data) {
        setDetails(data);
      }
    };
    request();
  }, [id]);

  if (!details) return null;

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      {typeSafeObjectKeys(bcRegions).map((key) => (
        <Styled.InfoRow key={key}>
          <Styled.InfoRowTitle>{bcRegions[key]}</Styled.InfoRowTitle>
          <Styled.InfoRowData>{details[key]}</Styled.InfoRowData>
        </Styled.InfoRow>
      ))}
    </Stack>
  );
};
